import React from 'react'

function Svg3(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={24}
      height={24}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.75 19H1.673v-5.332a2 2 0 011.077-1.775"
        stroke="currentColor"
      />
      <path
        d="M4.367 16.154a.5.5 0 00-1 0h1zm-1 2.75a.5.5 0 001 0h-1zm0-2.75v2.75h1v-2.75h-1z"
        fill="currentColor"
      />
      <path
        d="M10.822 11.25c.18-.481.278-1.002.278-1.546v-2.28a4.425 4.425 0 00-8.85 0v2.28a4.424 4.424 0 007 3.598"
        stroke="currentColor"
      />
      <path
        d="M2.254 7.252a4.42 4.42 0 003.63-1.899 4.42 4.42 0 003.633 1.9c.549 0 1.075-.1 1.56-.283a4.425 4.425 0 00-8.823.282z"
        stroke="currentColor"
      />
      <circle cx={4.879} cy={9.347} r={0.546} fill="currentColor" />
      <circle cx={8.548} cy={9.347} fill="currentColor" r={0.546} />
      <path
        d="M7.374 11.387a1.002 1.002 0 01-1.417 0"
        stroke="currentColor"
        strokeLinecap="round"
      />
      <path
        d="M15.5 19h6.75v-4.833c0-.699-.396-1.306-.976-1.608"
        stroke="currentColor"
      />
      <path
        d="M19.762 16.42a.5.5 0 011 0h-1zm1 2.493a.5.5 0 11-1 0h1zm0-2.492v2.492h-1v-2.492h1z"
        fill="currentColor"
      />
      <path
        d="M13.814 11.5a4.026 4.026 0 01-.107-.925V8.51a4.01 4.01 0 018.02 0v2.065a4.01 4.01 0 01-6.344 3.261L15 13.5"
        stroke="currentColor"
      />
      <path
        d="M21.723 8.354a4.005 4.005 0 01-3.29-1.721 4.005 4.005 0 01-4.705 1.465 4.01 4.01 0 017.995.256z"
        stroke="currentColor"
      />
      <circle
        transform="matrix(-1 0 0 1 19.345 10.252)"
        fill="currentColor"
        r={0.495}
      />
      <circle
        transform="matrix(-1 0 0 1 16.019 10.252)"
        fill="currentColor"
        r={0.495}
      />
      <path
        d="M17.084 12.101a.908.908 0 001.284 0"
        stroke="currentColor"
        strokeLinecap="round"
      />
      <path
        d="M9.75 17a1.998 1.998 0 00-.904 1.674v2.799h6.548v-2.8c0-.7-.36-1.316-.905-1.673"
        stroke="currentColor"
      />
      <path
        d="M10.782 19.61a.5.5 0 10-1 0h1zm-1 1.8a.5.5 0 101 0h-1zm0-1.8v1.8h1v-1.8h-1zM14.203 19.61a.5.5 0 10-1 0h1zm-1 1.8a.5.5 0 101 0h-1zm0-1.8v1.8h1v-1.8h-1z"
        fill="currentColor"
      />
      <rect
        x={9.224}
        y={11}
        width={5.792}
        height={7.284}
        rx={2.896}
        stroke="currentColor"
      />
      <path
        d="M9.736 13.765c.788 0 1.493-.36 1.957-.926.53.394 1.187.628 1.899.628h.074c.45 0 .879-.094 1.267-.262a2.897 2.897 0 00-5.704.51c.164.032.333.05.507.05z"
        stroke="currentColor"
      />
      <circle cx={10.944} cy={15.155} fill="currentColor" r={0.357} />
      <circle cx={13.346} cy={15.155} r={0.357} fill="currentColor" />
      <path
        d="M12.577 16.49a.656.656 0 01-.928 0"
        stroke="currentColor"
        strokeLinecap="round"
      />
    </svg>
  )
}

export default Svg3
